import React from "react";
import { connect } from "react-redux";
import DossierActions from "../redux/DossierRedux";
import Layout from "../components/Layout";
import HeaderForm from "../components/HeaderForm/HeaderForm";
import { Link } from "react-router-dom";
import Button from "../components/UI/Button/Button";
import Input from "../components/UI/Input/Input";
import InputEuroReadOnly from "../components/UI/Input/InputEuroReadOnly";
import FormError from "../components/UI/FormError/FormError";
import {
  updateObject,
  checkValidity,
  getEuro,
  isFormReadOnly,
  getFormErrors,
} from "../shared/utility";

import { votreActivite, votreBienForm2 } from "../shared/staticTexts";

class DossierVotreActivite extends React.Component {
  constructor(props) {
    super(props);

    if (props.dossier === null) {
      props.history.push("/dossier");
    }
    const dossier = props.dossier;
    const indexes = [
      "totalEncaisse",
      "totalDepensesCourantes",
      "totalTravaux",
      "depensesEquipement",
      "impotsTaxeFonciere",
      "impotsCFE",
      "chargesFinancieres",
      "empruntCapitalRestantDu",
    ];
    let totalInfosExercice = {};
    let totalInfosExerciceNM1 = {};
    indexes.forEach((idx) => {
      totalInfosExercice[idx] = 0;
      totalInfosExerciceNM1[idx] = 0;
    });

    dossier.biens.forEach((bien) => {
      if (bien.infosExercice) {
        const info = bien.infosExercice;
        const infoNM1 = bien.infosExerciceNM1;
        if (info) {
          indexes.forEach((idx) => {
            totalInfosExercice[idx] += info[idx] ? info[idx] : 0;
          });
        }
        if (infoNM1) {
          indexes.forEach((idx) => {
            totalInfosExerciceNM1[idx] += infoNM1[idx] ? infoNM1[idx] : 0;
          });
        }
      }
    });

    Object.keys(totalInfosExercice).forEach((key) => {
      totalInfosExercice[key] =
        totalInfosExercice[key] > 0 ? getEuro(totalInfosExercice[key]) : "";
    });

    Object.keys(totalInfosExerciceNM1).forEach((key) => {
      totalInfosExerciceNM1[key] =
        totalInfosExerciceNM1[key] > 0
          ? getEuro(totalInfosExerciceNM1[key])
          : "";
    });

    this.state = {
      form: {
        commentaire: {
          elementType: "textarea",
          elementConfig: {
            type: "textarea",
            name: "commentaire",
            placeholder: votreActivite.form.commentaire.placeholder,
          },
          validation: {},
          value:
            dossier !== null && dossier.commentaire ? dossier.commentaire : "",
          valid: false,
          touched: false,
        },
      },
      formErrors: [],
      formIsValid: false,
      isSubmitted: false,
      dossier: dossier,
      totalInfosExercice: totalInfosExercice,
      totalInfosExerciceNM1: totalInfosExerciceNM1,
      isReadOnlyForm: isFormReadOnly(dossier),
    };
  }

  static getDerivedStateFromProps = (nextProps, prevState) => {
    if (
      prevState.isSubmitted &&
      nextProps.dossier !== null &&
      prevState.dossier !== null
    ) {
      if (nextProps.dossier !== prevState.dossier) {
        nextProps.history.replace("/dossier/votre-liasse-fiscale");
      }
    }
    return nextProps;
  };

  submitHandler = (event) => {
    event.preventDefault();

    if (
      this.props.dossier &&
      this.props.dossier.status &&
      this.props.dossier.status !== "EnSaisie"
    ) {
      this.props.history.replace("/dossier/votre-liasse-fiscale");
      return false;
    }

    let formElements = {};
    for (let formElementIdentifier in this.state.form) {
      const formElementValue = this.state.form[formElementIdentifier].value;
      const updatedFormElement = updateObject(
        this.state.form[formElementIdentifier],
        {
          value: formElementValue,
          valid: checkValidity(
            formElementValue,
            this.state.form[formElementIdentifier].validation
          ),
          touched: true,
        }
      );

      formElements[formElementIdentifier] = updatedFormElement;
    }

    let formIsValid = true;
    let formData = {};
    for (let formElementIdentifier in formElements) {
      formIsValid = formElements[formElementIdentifier].valid && formIsValid;
      const value = formElements[formElementIdentifier].value;
      formData[formElementIdentifier] = value;
    }

    this.setState({
      form: formElements,
      formIsValid: formIsValid,
      formErrors: getFormErrors(formElements),
    });

    if (formIsValid) {
      let {
        timestampCreation,
        timestampModification,
        ...dossier
      } = this.props.dossier;

      dossier.commentaire = formData.commentaire;
      dossier.status =
        dossier.status !== "Termine" ? "EnTraitement" : dossier.status;

      this.setState({ isSubmitted: true });
      this.props.saveDossier(dossier);
    }
  };

  inputChangedHandler = (event, inputIdentifier) => {
    const updatedFormElement = updateObject(this.state.form[inputIdentifier], {
      value: event.target.value,
      valid: checkValidity(
        event.target.value,
        this.state.form[inputIdentifier].validation
      ),
      touched: true,
    });

    const updatedForm = updateObject(this.state.form, {
      [inputIdentifier]: updatedFormElement,
    });

    let formIsValid = true;
    for (let inputIdentifier in updatedForm) {
      formIsValid = updatedForm[inputIdentifier].valid && formIsValid;
    }

    this.setState({
      form: updatedForm,
      formIsValid: formIsValid,
    });
  };

  render() {
    let errorsMessages = "";
    if (this.props.error && this.props.errorMessage !== null) {
      errorsMessages = (
        <div className="alert alert-danger" role="alert">
          {this.props.errorMessage}
        </div>
      );
    }

    const formElementsArray = [];
    for (let key in this.state.form) {
      formElementsArray.push({
        id: key,
        config: this.state.form[key],
      });
    }

    const totalInfosExercice = this.state.totalInfosExercice;
    const totalInfosExerciceNM1 = this.state.totalInfosExerciceNM1;

    let annee = "";
    if (this.props.dossier !== null) {
      annee = this.props.dossier.annee;
    }

    let form = (
      <form className="dossier-form py-5" onSubmit={this.submitHandler}>
        <fieldset className="bien-fs-border">
          <legend className="bien-fs-border">
            {votreActivite.form.fieldset1.replace("{annee}", annee)}
          </legend>
          <div className="control-group">
            <div className="form-row mb-3 pt-4">
              <div className="col-sm-4 text-right">
                <label className="col-form-label">
                  {votreBienForm2.form.totalEncaisse.label1}
                  <br />
                  {votreBienForm2.form.totalEncaisse.label2}
                </label>
              </div>
              <div className="col-sm-3">
                <InputEuroReadOnly value={totalInfosExercice.totalEncaisse} />
              </div>
              <div className="col-sm-3">
                <label className="readonly-label">Rappel {annee - 1}</label>
                <InputEuroReadOnly
                  value={totalInfosExerciceNM1.totalEncaisse}
                />
              </div>
            </div>
          </div>
        </fieldset>

        <fieldset className="bien-fs-border">
          <legend className="bien-fs-border">
            {votreActivite.form.fieldset2.replace("{annee}", annee)}
          </legend>
          <div className="control-group">
            <div className="form-row mb-3 pt-4">
              <div className="col-sm-6 text-right">
                <label className="col-form-label">
                  {votreBienForm2.form.totalDepensesCourantes.label1}
                  <br />
                  <small>
                    {votreBienForm2.form.totalDepensesCourantes.label2}
                  </small>
                </label>
              </div>
              <div className="col-sm-3">
                <InputEuroReadOnly
                  value={totalInfosExercice.totalDepensesCourantes}
                />
              </div>
              <div className="col-sm-3">
                <label className="readonly-label">Rappel {annee - 1}</label>
                <InputEuroReadOnly
                  value={totalInfosExerciceNM1.totalDepensesCourantes}
                />
              </div>
            </div>

            <div className="form-row mb-3 pt-4">
              <div className="col-sm-6 text-right">
                <label className="col-form-label">
                  {votreBienForm2.form.totalTravaux.label1.replace(
                    "{annee}",
                    annee
                  )}
                  <br />
                  <small>{votreBienForm2.form.totalTravaux.label2}</small>
                </label>
              </div>
              <div className="col-sm-3">
                <InputEuroReadOnly value={totalInfosExercice.totalTravaux} />
              </div>
              <div className="col-sm-3">
                <InputEuroReadOnly value={totalInfosExerciceNM1.totalTravaux} />
              </div>
            </div>

            <div className="form-row mb-3 pt-4">
              <div className="col-sm-6 text-right">
                <label className="col-form-label">
                  {votreBienForm2.form.depensesEquipement.label.replace(
                    "{annee}",
                    annee
                  )}
                </label>
              </div>
              <div className="col-sm-3">
                <InputEuroReadOnly
                  value={totalInfosExercice.depensesEquipement}
                />
              </div>
              <div className="col-sm-3">
                <InputEuroReadOnly
                  value={totalInfosExerciceNM1.depensesEquipement}
                />
              </div>
            </div>

            <div className="form-row mb-3 pt-4">
              <div className="col-sm-6 text-right">
                <label className="col-form-label">
                  {votreBienForm2.form.impotsTaxeFonciere.label1}
                  <br />
                  <small>{votreBienForm2.form.impotsTaxeFonciere.label2}</small>
                </label>
              </div>
              <div className="col-sm-3">
                <InputEuroReadOnly
                  value={totalInfosExercice.impotsTaxeFonciere}
                />
              </div>
              <div className="col-sm-3">
                <InputEuroReadOnly
                  value={totalInfosExerciceNM1.impotsTaxeFonciere}
                />
              </div>
            </div>

            <div className="form-row mb-3 pt-4">
              <div className="col-sm-6 text-right">
                <label className="col-form-label">
                  {votreBienForm2.form.impotsCFE.label1}
                  <br />
                  <small>{votreBienForm2.form.impotsCFE.label2}</small>
                </label>
              </div>
              <div className="col-sm-3">
                <InputEuroReadOnly value={totalInfosExercice.impotsCFE} />
              </div>
              <div className="col-sm-3">
                <InputEuroReadOnly value={totalInfosExerciceNM1.impotsCFE} />
              </div>
            </div>

            <div className="form-row mb-3 pt-4">
              <div className="col-sm-6 text-right">
                <label className="col-form-label">
                  {votreBienForm2.form.chargesFinancieres.label1}
                  <br />
                  {votreBienForm2.form.chargesFinancieres.label2}
                  <br />
                  <small>{votreBienForm2.form.chargesFinancieres.label3}</small>
                </label>
              </div>
              <div className="col-sm-3">
                <InputEuroReadOnly
                  value={totalInfosExercice.chargesFinancieres}
                />
              </div>
              <div className="col-sm-3">
                <InputEuroReadOnly
                  value={totalInfosExerciceNM1.chargesFinancieres}
                />
              </div>
            </div>
          </div>
        </fieldset>

        <fieldset className="bien-fs-border">
          <legend className="bien-fs-border">
            {votreActivite.form.fieldset3}
          </legend>
          <div className="control-group">
            <div className="form-row mb-3 pt-4">
              <div className="col-sm-4 text-right">
                <label className="col-form-label">
                  {votreBienForm2.form.empruntCapitalRestantDu.label.replace(
                    "{annee}",
                    annee
                  )}
                </label>
              </div>
              <div className="col-sm-3">
                <InputEuroReadOnly
                  value={totalInfosExercice.empruntCapitalRestantDu}
                />
              </div>
              <div className="col-sm-3">
                <InputEuroReadOnly
                  value={totalInfosExerciceNM1.empruntCapitalRestantDu}
                />
              </div>
            </div>
          </div>
        </fieldset>

        <fieldset className="bien-fs-border">
          <legend className="bien-fs-border">
            {votreActivite.form.fieldset4.replace("{annee}", annee)}
          </legend>
          <div className="control-group">
            <div className="form-row mb-3 pt-4">
              <div className="col-sm-12">
                <Input
                  key={formElementsArray[0].id}
                  elementType={formElementsArray[0].config.elementType}
                  elementConfig={formElementsArray[0].config.elementConfig}
                  label={formElementsArray[0].config.label}
                  value={formElementsArray[0].config.value}
                  invalid={!formElementsArray[0].config.valid}
                  shouldValidate={formElementsArray[0].config.validation}
                  touched={formElementsArray[0].config.touched}
                  isReadOnly={this.state.isReadOnlyForm}
                  changed={(event) =>
                    this.inputChangedHandler(event, formElementsArray[0].id)
                  }
                />
              </div>
            </div>
          </div>
        </fieldset>
        <div className="form-row">
          <div className="mt-3 col-sm-12 text-right">
            <Link to="/dossier/votre-bien" className="btn btn-default mr-3">
              {votreActivite.buttonReturn}
            </Link>
            <Button
              classes="btn btn-success"
              btnType="Submit"
              disabled={this.state.isReadOnlyForm}
            >
              {votreActivite.buttonSubmit}
            </Button>
          </div>
        </div>

        <FormError errors={this.state.formErrors} fullColumn="true" />
      </form>
    );

    return (
      <Layout>
        {errorsMessages}
        <HeaderForm
          step="3"
          annee={annee}
          isReadOnlyForm={this.state.isReadOnlyForm}
        />
        <h1 className="text-center">Récapitulatif de vos éléments {annee}</h1>
        {form}
      </Layout>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    dossier: state.dossiers.dossier,
    isFetching: state.dossiers.fetching,
    error: state.dossiers.error,
    errorMessage: state.dossiers.errorMessage,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    saveDossier: (dossier) => dispatch(DossierActions.saveDossier(dossier)),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(DossierVotreActivite);
